import React from 'react';
import PropTypes from 'prop-types';

import TeamListItem from './TeamListItem';

const TeamListItems = ({
  handleSelection,
  items = [],
  selectedItems = [],
  handleExpendTree,
  position,
}) => {
  const renderList = () =>
    items.map(item => {
      item.selected =
        selectedItems &&
        selectedItems.indexOf(item.itemId) >= 0;
      return (
        <TeamListItem
          key={item.itemId}
          {...item}
          listid={item.id}
          handleSelection={handleSelection}
          handleExpendTree={handleExpendTree}
          position={position}
        />
      );
    });

  return (
    <div className="multi-select-list">
      <ul
        className="vertical dropdown menu user-select-none"
        data-dropdown-menu
      >
        {renderList()}
      </ul>
    </div>
  );
};

TeamListItems.propTypes = {
  position: PropTypes.string,
  handleSelection: PropTypes.func,
  handleExpendTree: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.instanceOf(Array),
};

export default TeamListItems;
